import http from '@/http'

/**
 * http://192.168.4.60:3000/project/84/interface/api/cat_3978
 * @type {{operationAesKeys: string, operationEnums: string}}
 */
const API = {
  operationEnums: '/operation/v1/enums', // 查询系统枚举信息 get
  interfaceOfOperationAesKeys: '/login/v1/aes/keys', // 查询系统AES秘钥key get
  interfaceOfLogin: '/login/v1/tokens', // 查询系统AES秘钥key get
  interfaceOfSms: '/login/v1/sms', // 获取短信验证码
  interfaceOfSupplierOptions: '/base/v1/suppliers/selections', // 获取供应商列表
  interfaceOfSupplierEnableOptions: '/base/v1/suppliers', // 获取供应商列表 已禁用的剔除掉
  interfaceOfDfcGoodsLabelOptions: '/goods/v1/dfcGoodsLabel/listEnable', // 商品标签的可选项
  interfaceOfStorageOptions: '/base/storage/search', // 仓库 全部
  interfaceOfStorageOptions2: '/base/storage/standard/search', // 仓库 全部
  interfaceOfStorageOptions3: '/base/storage/searchAll', // 仓库 全部

  queryStoreAndStorage: '/goods/v1/dfc/queryStoreAndStorage', // 仓库店铺
  interfaceOfColorSearch: '/goods/v1/color/list?pageNo=1&pageSize=1000', // 全部颜色
  interfaceOfSizeSearch: '/goods/v1/size/list?pageNo=1&pageSize=1000', // 全部尺码
  interfaceOfExports: '/imports/v1/exports', // 所有的报表导出
  interfaceOfExportsSecond: '/imports/v1/exports/search', // 任务中心 所有的报表导出
  interfaceOfExportsDelete: '/imports/v1/exports', // 任务中心 所有的报表的清空  delete方式
  interfaceOfStoreSelectionsQuery: '/base/store/selectionsQuery', // 查询当前用户所在店铺 停用店铺一起查出
  interfaceOfStoreSelections: '/base/store/selections', // 查询当前用户所在店铺 停用店铺不会查出来
  interfaceOfEmployeesSelections: '/user/v1/employees', // 查询 店员  开单员 /user/v1/employees/selections
  interfaceOfCustomersListInfoAndBalance: '/member/v1/customers/searchForOrder', // 查询 客户
  interfaceOfCustomerTypes: '/base/v1/customerTypes', // 会员等级
  interfaceOfSettleWaysSelections: '/base/v1/settleWays/selections', // 商户所有的结算方式
  interfaceOfPriceTypes: '/bi/v1/pcReports/priceTypes', // 商户下的所有价格类型
  interfaceOfStoreSelectionsempRealName: '/user/v1/employees/empRealName/list', // 员工全名

  interfaceOfSetting: '/balance/v1/setting/get', // 获取储值设置
  interfaceOfShowIntegralStatus: '/integral/v1/config/showIntegralStatus', // 查找商户当前积分功能是否开启
  interfaceOfStoreSelectselections: '/base/v1/customerTypes/selections', // 查询当前用户所在店铺 停用店铺一起查出
  articleColumns: '/thirdparty/wx/community/tab/list', // 专栏列表
  interfaceOfStorePayList: '/base/v1/settleWays/getByStoreId', // 门店支持的支付方式
  interfacesSupplierVerifyPage: '/order/purchase/supplierVerifyPage', // 获取供应商核销列表

  interfaceChannelList: '/base/v1/channel/search', // 渠道列表
  interfaceChannelStatistic: '/base/v1/channel/listStatistic', // 渠道列表统计信息
  getChannelStoreStatistic: 'base/v1/channel/getChannelStoreStatistic', // 单个渠道的统计信息
  getChannelStoreSettle: 'base/v1/channel/queryAccountLog', // 渠道的账单信息
  getChannelStoreSettleStatistic: 'base/v1/channel/queryAccountLogTotal', // 门店账单统计头信息
  exportChannelStoreSettle: 'export/v1/channelStoreAccounts/export', // 账单导出
  getSeasonList: '/goods/v1/goods/season/list', // 季节列表
  createSeason: '/goods/v1/goods/season', // 新增季节
  getBlueToothTemplates: 'base/v2/blueToothTemplates/manages', // 蓝牙打印机模板列表V2
  channelAdd: '/base/v1/channel/add', // 新增渠道
  selectionsQuery: '/base/v1/channel/selectionsQuery', // 渠道列表

  interfaceOflistInfoAndBalance: '/member/v1/customers/listInfoAndBalance', // 销售开单 客户
  interfaceOfOperationSearch: '/base/store/operationSearch', // 销售开单 店铺

  interfaceOfRecentProductPrice: '/goods/v1/order/recentProductPrice', // 获取上次成交价

  selectionsOfCustomerTypes: '/base/v1/customerTypes/selections/auth', // 会员等级
  selectionsOfCustomerLabels: '/member/v1/customerLabels/selections', // 客户标签
  selectionsOfCustomerAccountList: '/member/v1/customers/getCustomerInitAccountList', // 客户期初结余/欠款初始金额
  createCustomer: '/member/v1/customers', // 创建/编辑客户
  queryCustomer: '/member/v1/customers/basic', // 查询客户
  getOrderEditLimit: '/base/v1/ruleInfos/getOrderEditLimit', // 时间限制权限

  interfaceOfManufacturerSelections: '/base/v1/manufacturers/selections', // 买手列表
  interfaceOfCustomersList: '/member/v1/customers/list', // 客户列表
}

// 时间限制权限
export function getOrderEditLimit() {
  return http.get({
    url: API.getOrderEditLimit,
  })
}

// 查询客户
export function queryCustomer(options) {
  return http.get({
    url: `/member/v1/customers/basic/${options}`,
  })
}

// 获取客户类型
export function getCustomerType(customerId) {
  return http.get({
    url: `/base/v1/customer/type/${customerId}`,
  })
}

// 获取会员等级列表
export function selectionsOfCustomerTypes(options) {
  return http.get({
    ...options,
    url: API.selectionsOfCustomerTypes,
  })
}

// 获取客户期初结余/欠款初始金额列表
export function selectionsOfCustomerAccountList(options) {
  return http.get({
    ...options,
    url: API.selectionsOfCustomerAccountList,
  })
}

// 获取客户标签列表
export function selectionsOfCustomerLabels(options) {
  return http.get({
    ...options,
    url: API.selectionsOfCustomerLabels,
  })
}

// 获取店铺标签列表
export function selectionsOfStoreLabels(options) {
  return http.post({
    ...options,
    url: '/base/store/listByOption',
  })
}

// 渠道信息列表
export function createCustomer(options) {
  return http.post({
    ...options,
    url: API.createCustomer,
  })
}
//编辑客户信息
export function editCustomer(options) {
  return http.put({
    ...options,
    url: API.createCustomer,
  })
}

// 渠道信息列表
export function interfaceChannelList(options) {
  return http.post({
    ...options,
    url: API.interfaceChannelList,
  })
}

export function exportChannelStoreSettle(options) {
  return http.post({
    ...options,
    // responseType: 'blob',
    url: API.exportChannelStoreSettle,
  })
}

export function getChannelStoreSettleStatistic(options) {
  return http.post({
    ...options,
    url: API.getChannelStoreSettleStatistic,
  })
}

export function getChannelStoreStatistic(options) {
  return http.get({
    ...options,
    url: API.getChannelStoreStatistic,
  })
}
export function interfaceChannelStatistic(options) {
  return http.post({
    ...options,
    url: API.interfaceChannelStatistic,
  })
}
export function getChannelStoreSettle(options) {
  return http.post({
    ...options,
    url: API.getChannelStoreSettle,
  })
}

/**
 * 查询当前用户所在店铺
 * @param options
 * @returns {*}
 */
export function interfaceOfStoreSelections(options) {
  return http.get({
    ...options,
    url: API.interfaceOfStoreSelections,
  })
}

/**
 * 查找商户当前积分功能是否开启
 * @param options
 * @returns {*}
 */
export function interfaceOfShowIntegralStatus(options) {
  return http.get({
    ...options,
    url: API.interfaceOfShowIntegralStatus,
  })
}

/**
 * 获取储值设置
 * @param options
 * @returns {*}
 */
export function interfaceOfSetting(options) {
  return http.get({
    ...options,
    url: API.interfaceOfSetting,
  })
}

/**
 * 查询当前用户所在店铺 停用店铺一起查出
 * @param options
 * @returns {*}
 */
export function interfaceOfStoreSelectionsQuery(options) {
  return http.post({
    ...options,
    url: API.interfaceOfStoreSelectionsQuery,
  })
}

export function interfaceOfOperationSearch(options) {
  return http.post({
    ...options,
    url: API.interfaceOfOperationSearch,
  })
}

/**
 * desc: /user/v1/employees/empRealName/list
 * @param {*} options
 * @returns
 */
export function interfaceOfStoreSelectionsempRealName(options) {
  return http.get({
    ...options,
    url: API.interfaceOfStoreSelectionsempRealName,
  })
}

/**
 * 查询会员等级下拉选择
 * @param options
 * @returns {*}
 */
export function interfaceOfStoreSelectselections(options) {
  return http.get({
    ...options,
    url: API.interfaceOfStoreSelectselections,
  })
}

export function interfaceOfStorePayList(options) {
  return http.get({
    ...options,
    url: API.interfaceOfStorePayList,
  })
}
/**
 * 查询栏目列表
 * @param options
 * @returns {*}
 */
export function articleColumns(options) {
  return http.get({
    ...options,
    url: API.articleColumns,
  })
}

export function interfaceOflistInfoAndBalance(options) {
  return http.get({
    ...options,
    url: API.interfaceOflistInfoAndBalance,
  })
}

/**
 * 查询 客户列表
 * @param options
 * @returns {*}
 */
export function interfaceOfCustomersList(options) {
  return http.post({
    ...options,
    url: API.interfaceOfCustomersList,
  })
}

/**
 * 查询 客户
 * @param options
 * @returns {*}
 */
export function interfaceOfCustomersListInfoAndBalance(options) {
  return http.get({
    ...options,
    url: API.interfaceOfCustomersListInfoAndBalance,
  })
}

/**
 * 查询 店员 开单员
 * @param options
 * @returns {*}
 */
export function interfaceOfEmployeesSelections(options) {
  return http.get({
    ...options,
    url: API.interfaceOfEmployeesSelections,
  })
}

/**
 * 查询系统枚举信息
 * @param options
 * @returns {*}
 */
export function operationEnums(options) {
  return http.get({
    ...options,
    url: API.operationEnums,
  })
}

/**
 * 查询系统AES秘钥key
 * @param options
 * @returns {*}
 */
export function interfaceOfOperationAesKeys(options) {
  return http.get({
    ...options,
    url: API.interfaceOfOperationAesKeys,
  })
}

/**
 * 登陆
 * @param options
 * @returns {*}
 */
export function interfaceOfLogin(options) {
  return http.post({
    ...options,
    url: API.interfaceOfLogin,
  })
}

/**
 * 获取短信验证码
 * @param options
 * @returns {*}
 */
export function interfaceOfSms(options) {
  return http.post({
    ...options,
    url: API.interfaceOfSms,
  })
}

/**
 * 新增供应商
 * @param options
 * @returns {*}
 */
export function addSupplier(data) {
  return http.post({
    data,
    url: '/base/v1/suppliers',
  })
}

/**
 * 获取供应商可选项
 * @param options
 * @returns {*}
 */
export function interfaceOfSupplierOptions(options) {
  return http.get({
    ...options,
    url: API.interfaceOfSupplierOptions,
  })
}

export function interfaceOfStoreOptions(options) {
  return http.post({
    ...options,
    url: '/base/store/listByOption',
  })
}

export function interfaceCustomersRequired(options) {
  return http.get({
    ...options,
    url: '/member/v1/customers/get/required',
  })
}

/**
 * 获取供应商可选项 已禁用的剔除掉
 * @param options
 * @returns {*}
 */
export function interfaceOfSupplierEnableOptions(options) {
  return http.get({
    ...options,
    url: API.interfaceOfSupplierEnableOptions,
  })
}

/**
 * 获取商品标签可选项
 * @param options
 * @returns {*}
 */
export function interfaceOfDfcGoodsLabelOptions(options) {
  return http.get({
    ...options,
    url: API.interfaceOfDfcGoodsLabelOptions,
  })
}

/**
 * 颜色模糊搜索
 * @param options
 * @returns {*}
 */
export function interfaceOfColorSearch(options) {
  return http.get({
    ...options,
    url: API.interfaceOfColorSearch,
  })
}

/**
 * 尺码模糊搜索
 * @param options
 * @returns {*}
 */
export function interfaceOfSizeSearch(options) {
  return http.get({
    ...options,
    url: API.interfaceOfSizeSearch,
  })
}

/**
 * 仓库
 * @param options
 * @returns {*}
 */
export function interfaceOfStorageOptions(options) {
  return http.post({
    ...options,
    url: API.interfaceOfStorageOptions,
  })
}
export function interfaceOfStorageOptions2(options) {
  return http.post({
    ...options,
    url: API.interfaceOfStorageOptions2,
  })
}
export function interfaceOfStorageOptions3(options) {
  return http.post({
    ...options,
    url: API.interfaceOfStorageOptions3,
  })
}
/**
 * 仓库店铺
 * @param options
 * @returns {*}
 */

export function queryStoreAndStorage(options) {
  return http.get({
    ...options,
    url: API.queryStoreAndStorage,
  })
}

/**
 * 查询会员等级
 * @param options
 * @returns {*}
 */
export function interfaceOfCustomerTypes(options) {
  return http.get({
    ...options,
    url: API.interfaceOfCustomerTypes,
  })
}

/**
 * 商户下所有的 结算方式
 * @param options
 * @returns {*}
 */
export function interfaceOfSettleWaysSelections(options) {
  return http.get({
    ...options,
    url: API.interfaceOfSettleWaysSelections,
  })
}

/**
 * 商户下所有的 价格类型
 * @param options
 * @returns {*}
 */
export function interfaceOfPriceTypes(options) {
  return http.get({
    ...options,
    url: API.interfaceOfPriceTypes,
  })
}

/**
 * 所有的报表导出
 * @param options
 * @returns {*}
 */
export function interfaceOfExports(options) {
  return http.post({
    ...options,
    url: API.interfaceOfExports,
  })
}

/**
 * 所有的报表导出 添加到任务中心后的导出
 * @param options
 * @returns {*}
 */
export function interfaceOfExportsSecond(options) {
  return http.post({
    ...options,
    url: API.interfaceOfExportsSecond,
  })
}

/**
 * 所有的报表导出 添加到任务中心后的导出
 * @param options
 * @returns {*}
 */
export function interfaceOfExportsDelete(options) {
  return http.delete({
    ...options,
    url: API.interfaceOfExportsDelete,
  })
}

/**
 * 获取供应商核销列表
 * @param options
 * @returns {*}
 */
export function interfacesSupplierVerifyPage(options) {
  return http.post({
    ...options,
    url: API.interfacesSupplierVerifyPage,
  })
}

/**
 * 蓝牙打印机模板列表V2
 * @param options
 * @returns {*}
 */
export function getBlueToothTemplates(options) {
  return http.post({
    ...options,
    url: API.getBlueToothTemplates,
  })
}

// 新增渠道
export function channelAdd(options) {
  return http.post({
    ...options,
    url: API.channelAdd,
  })
}

// 获取季节列表
export function getSeasonList(options) {
  return http.post({
    url: API.getSeasonList,
  })
}

// 新增季节
export function createSeason(options) {
  return http.post({
    ...options,
    url: API.createSeason,
  })
}

// 获取打印机详细配置
export function getBlueToothTemplatesManage(options) {
  const {
    data: { id },
  } = options
  return http.get({
    url: `/base/v2/blueToothTemplates/manage/${id}`,
  })
}

export function infoMap(options) {
  return http.get({
    ...options,
    url: '/base/v1/ruleInfos/infoMap',
  })
}

// 渠道列表
export function selectionsQuery(options) {
  return http.post({
    ...options,
    url: API.selectionsQuery,
  })
}

/**
 * 查询商品最近成交价及会员折扣价
 * docs: http://192.168.4.60:3000/project/143/interface/api/18869
 * */
export function interfaceOfRecentProductPrice(options) {
  return http.post({
    ...options,
    url: API.interfaceOfRecentProductPrice,
  })
}

export function interfaceOfCustomerLabels(options) {
  return http.get({
    ...options,
    url: '/member/v1/customerLabels/selections',
  })
}

// https://app.apifox.com/project/2061595/apis/api-101528109
export function interfaceOfExpandInfo(options) {
  return http.get({
    ...options,
    url: `/goods/v1/goods/expandInfo/list`,
  })
}

// https://app.apifox.com/project/2061595/apis/api-101528109
export function interfaceOfGoodsExpandInfo(options) {
  return http.post({
    ...options,
    url: '/goods/v1/goods/expandInfo',
  })
}

// http://192.168.4.60:3000/project/116/interface/api/98067
export function interfaceOfRuleInfosSelections(options) {
  return http.get({
    ...options,
    url: `/base/v1/ruleInfos/selections`,
  })
}

export function addcolor(options) {
  return http.post({
    ...options,
    url: '/goods/v1/color',
  })
}
export function addsize(options) {
  return http.post({
    ...options,
    url: '/goods/v1/size',
  })
}

// 获取默认店铺
export function getDefaultStorageOrStore(options) {
  return http.get({
    ...options,
    url: '/base/store/getDefaultStorageOrStore',
  })
}

// 查询按门店区分客户的区分设置
export function distinguishSet(options) {
  return http.get({
    ...options,
    url: '/base/v1/tenantSetting/distinguishSet',
  })
}

// 获取标签
export function getStoreGoodsLabel(params) {
  return http.get({
    params,
    url: '/goods/v1/storeGoodsLabel/listEnable',
  })
}

/**
 * 客户上下级
 */
export function getParentCustomer(options) {
  return http.post({
    ...options,
    url: '/member/v1/bindParentCustomer/list',
  })
}

/**
 * 查客户的下级客户
 */
export function listChildCustomer(options) {
  return http.post({
    ...options,
    url: '/member/v1/customer/listChild',
  })
}

export function getruleInfos(id) {
  return http.get({
    url: `/base/v1/ruleInfos/${id}`,
  })
}

/**
 * 根据id查找员工 零售版
 */
export function queryStoreAndStorageVirtual(employeeId) {
  return http.get({
    url: `/user/v1/employees/standard/${employeeId}`,
  })
}

export function interfaceOfManufacturerSelections(options) {
  return http.get({
    ...options,
    url: API.interfaceOfManufacturerSelections,
  })
}

const common = {
  queryCustomer,
  addcolor,
  addsize,
  infoMap,
  interfaceOfGoodsExpandInfo,
  interfaceOfRuleInfosSelections,
  interfaceOfExpandInfo,
  operationEnums,
  interfaceOfOperationAesKeys,
  interfaceOfRecentProductPrice,
  interfaceOfLogin,
  interfaceOfSms,
  interfaceOfSupplierOptions,
  interfaceOfDfcGoodsLabelOptions,
  interfaceOfStorageOptions,
  interfaceOfStorageOptions2,
  queryStoreAndStorage,
  interfaceOfColorSearch,
  interfaceOfSizeSearch,
  interfaceOfStoreSelectionsQuery,
  interfaceOfStoreSelectionsempRealName,
  interfaceOfEmployeesSelections,
  interfaceOfCustomersListInfoAndBalance,
  interfaceOfCustomersList,
  interfaceOfStoreSelections,
  interfaceOfCustomerTypes,
  interfaceOfSettleWaysSelections,
  interfaceOfExports,
  interfaceOfExportsSecond,
  interfaceOfExportsDelete,
  interfaceOfPriceTypes,
  interfaceOfStoreSelectselections,
  interfaceOflistInfoAndBalance,
  interfaceOfOperationSearch,
  articleColumns,
  interfaceOfSupplierEnableOptions,
  getSeasonList,
  createSeason,
  selectionsQuery,
  selectionsOfCustomerTypes,
  interfaceOfCustomerLabels,
  interfaceOfStoreOptions,
  distinguishSet,
  getParentCustomer,
  listChildCustomer,
  getruleInfos,
  queryStoreAndStorageVirtual,
  interfaceOfManufacturerSelections,
}

export default common
